import { ArrowRightIcon } from "@heroicons/react/outline";
import { useParams } from "react-router-dom";

import { useEvent } from "../../changelog-item-context";
import EntityLink from "../EntityLink";

import EventTitleWrapper, { ActionText } from "./EventTitleWrapper";

import { getItemLink } from "@/components/UnifiedRegistry/utils";
import { ActionType, ChangelogEntry, Entity } from "@/queries";

const RenameEventTitle = () => {
  const event = useEvent<ChangelogEntry<ActionType.RENAME>>();
  const { workspaceId } = useParams();

  const link = event.entity_id
    ? getItemLink(
        {
          id: event.entity_id,
          type: event.entity_type,
        } as Entity,
        Number(workspaceId),
      )
    : undefined;

  return (
    <EventTitleWrapper>
      <ActionText>Renamed</ActionText>
      <EntityLink
        type={event.entity_type}
        name={event.action_payload?.old_name || ""}
        className="opacity-60 hover:opacity-100"
        link={link}
      />
      <ArrowRightIcon className="h-3 w-3 flex-shrink-0 text-gray-400" />
      <EntityLink
        type={event.entity_type}
        name={event.action_payload?.new_name || ""}
        link={link}
      />
    </EventTitleWrapper>
  );
};

export default RenameEventTitle;
